import fetch from "isomorphic-fetch";

export const subscribe = (body) => (dispatch) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.REACT_APP_URL}/${
        process.env.REACT_APP_ENV || "dev"
      }/subscribe`,
      {
        body: JSON.stringify(body),
        method: "POST",
      }
    )
      .then((res) => res.json())
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
};

export const checkSubscription = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.REACT_APP_URL}/${
        process.env.REACT_APP_ENV || "dev"
      }/subscribe/` + id
    )
      .then((res) => res.json())
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
};

export const endSubscription = (id) => (dispatch) => {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.REACT_APP_URL}/${
        process.env.REACT_APP_ENV || "dev"
      }/unsubscribe/` + id
    )
      .then((res) => res.json())
      .then((data) => resolve(data))
      .catch((err) => reject(err));
  });
};

export const sumterSubscribe = (id) => (dispatch) => {
    return new Promise((resolve, reject) => {
        fetch(
            `${process.env.REACT_APP_URL}/${
            process.env.REACT_APP_ENV || "dev"
            }/sumterSubscribe/` + id
        )
            .then((res) => res.json())
            .then((data) => resolve(data))
            .catch((err) => reject(err));
    });
};
